import { render } from "./HomePage.vue?vue&type=template&id=d5af3c6a&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=d5af3c6a&scoped=true&lang=css"

import exportComponent from "../../dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5af3c6a"]])

export default __exports__